import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAccount, useReadContract } from "wagmi";

import { factoryAbi } from "../contracts/factoryAbi";
import { factoryAddress } from "../contracts/factoryAddress";

type AdminRouteProps = {
  children: ReactNode;
};

function normalize(value: unknown): string {
  return typeof value === "string" ? value.toLowerCase() : "";
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { address } = useAccount();

  const { data: ownerRaw } = useReadContract({
    address: factoryAddress,
    abi: factoryAbi,
    functionName: "owner",
  });

  const owner = normalize(ownerRaw);
  const wallet = normalize(address);

  const isOwner = wallet && wallet === owner;

  if (!isOwner) {
    return (
      <div className="mx-auto max-w-4xl px-4 py-12">
        <div className="rounded-xl border bg-card p-6">
          <h1 className="text-xl font-semibold">Admin access only</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            This page is only available for the Orion owner wallet.
          </p>

          <Link
            to="/"
            className="mt-4 inline-flex rounded-lg border px-4 py-2 text-sm"
          >
            Back to markets
          </Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}